import React from 'react';
import { designBaseUrl } from '../../lib/FL';

import contentCommonStyles from './ContentPreview.module.scss';
import styles from './BukkenListDetailPreview.module.scss';

const BukkenMapPreviewPc: React.FC = () => (
  <div className={`${contentCommonStyles.content} ${styles.content_pcList}`}>
    <div className={styles.content__search}>
      <img
        className={styles.content__searchImage}
        src={`${designBaseUrl}/assets/formatline/design/pc/common/map_left.png`}
        alt='サンプル画像'
      />
      <img
        className={styles.content__searchButtonImage}
        src={`${designBaseUrl}/assets/formatline/design/pc/common/button_pc.png`}
        alt='この条件で検索'
      />
    </div>
    <div className={styles.content__list}>
      <img
        className={styles.content__listImage}
        src={`${designBaseUrl}/assets/formatline/design/pc/common/map_right.png`}
        alt='サンプル画像'
      />
    </div>
  </div>
);

const BukkenMapPreviewSp: React.FC = () => (
  <div className={contentCommonStyles.content}>
    <img src={`${designBaseUrl}/assets/formatline/design/sp/common/map.png`} alt='サンプル画像' />
  </div>
);

type Props = {
  device: string;
};

export const BukkenMapPreview: React.FC<Props> = ({ device }) =>
    (device === 'pc' ? <BukkenMapPreviewPc /> : <BukkenMapPreviewSp />);
